import { render, staticRenderFns } from "./MatchPositionWidget.vue?vue&type=template&id=628cc281&scoped=true&"
import script from "./MatchPositionWidget.vue?vue&type=script&lang=ts&"
export * from "./MatchPositionWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628cc281",
  null
  
)

export default component.exports